import { useEffect, useLayoutEffect, useRef, useState } from "react";
import { ROUTE } from "./Route/Route.types";

export const prepareDualListBox = (duallistbox: any) => {
    return duallistbox.map((item: any) => {
        item = {
            'value': item.id, 
            'label': `${item.name} ${item.required ? '*' : ''}`
        };
        return item;
    });
};

export const getEntityDisplayValue = (entity: any) => {
    switch (entity) {
        case 'candidate':
            return 'Kandidaten';
        case 'vacancy':
            return 'Vacatures';
        case 'business':
            return 'Bedrijven (OLD)';
        case 'business_unit':
            return 'Bedrijven';
        case 'contact':
            return 'Contactpersonen';
        case 'offer':
            return 'Aanbiedingen';
        default:
            return 'Entity niet herkent';
    }
}

export const getEntityRoute = (entity, id) => {
    switch (entity) {
        case 'candidate':
            return ROUTE.CANDIDATE.VIEW(id);
        case 'vacancy':
            return ROUTE.VACANCY.VIEW(id);
        case 'business':
            return ROUTE.BUSINESS.VIEW(id);
        case 'business_unit':    
            return ROUTE.BUSINESS_UNIT.VIEW(id);
        case 'contact':
            return ROUTE.CONTACT.VIEW(id);
        default:
            return '/';
    }
}

export const entityToLayout = {
    'candidate': 'candidates',
    'vacancy': 'vacancies',
    'business': 'businesses',
    'business_unit': 'business_units',
    'contact': 'contacts'
};

export function useOuterClick(callback) {
    const callbackRef: any = useRef();
    const innerRef: any = useRef();
  
    useEffect(() => { callbackRef.current = callback; });
    
    useEffect(() => {
      document.addEventListener("click", handleClick);
      return () => document.removeEventListener("click", handleClick);
      function handleClick(e) {
        if (innerRef.current && callbackRef.current && 
          !innerRef.current.contains(e.target)
        ) callbackRef.current(e);
      }
    }, []);
        
    return innerRef;
}

export function useOutsideAlerter(callback, reference: any[], isActive: boolean = true) {
    const ref: any = reference[0];
    useEffect(() => {
        function handleClickOutside(event) {
            const hasDropdownParent = event?.target?.className?.includes('dropdown')
                || event?.target?.parentNode?.className?.includes('dropdown')
                || event?.target?.parentNode?.parentNode?.className?.includes('dropdown');
            if (
                ref.current
                && !ref.current.contains(event.target)
                && !hasDropdownParent
            ) {
                callback();
            }
        }
        if (isActive) {
            document.addEventListener("mousedown", handleClickOutside);
            return () => {
                document.removeEventListener("mousedown", handleClickOutside);
            };
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ref, isActive]);
}

export const useIsOverflow = (ref, callback: any = undefined) => {
    const [isOverflow, setIsOverflow] = useState<any>(undefined);
  
    useLayoutEffect(() => {
      const { current } = ref;
  
      const trigger = () => {
        const hasOverflow = current.scrollWidth > current.clientWidth;

        setIsOverflow(hasOverflow);
  
        if (callback) callback(hasOverflow);
      };
  
      if (current) {
        trigger();
      }
    }, [callback, ref]);
  
    return isOverflow;
  };






  

export const getDatasetValueByKey = (datasets: any, key: any) => {
    if (!datasets) return;

    let isFound = false;
    for (const dataset of datasets) {
        if (isFound) continue;

        if (dataset.value == key) {
            isFound = true;
            return (dataset?.path) ? dataset?.path + '/' + dataset.title : dataset.title;
        }
    }

    if (!isFound) {
        let datasetsWithChildren: any = [];
        for (const dataset of datasets) {
            if (dataset.children) {
                for (const item of dataset.children) {
                    item.path = (dataset?.path) ? dataset?.path + '/' + dataset.title : dataset.title;
                }

                datasetsWithChildren = [...datasetsWithChildren, ...dataset?.children];
            }
        }

        if (datasetsWithChildren.length == 0) {
            return '';
        }

        return getDatasetValueByKey(datasetsWithChildren, key);
    }

    return '';
}

export const getDatasetValue = (datasets: any, key: any) => {
    if (!datasets) return;

    let isFound = false;
    for (const dataset of datasets) {
        if (isFound) continue;

        if (dataset.value == key) {
            isFound = true;
            return dataset;
        }
    }

    if (!isFound) {
        let datasetsWithChildren: any = [];
        for (const dataset of datasets) {
            if (!dataset.children) continue;
            datasetsWithChildren = [...datasetsWithChildren, ...dataset?.children];
        }

        if (datasetsWithChildren.length == 0) {
            return [];
        }
        
        return getDatasetValue(datasetsWithChildren, key);
    }

    return [];
}

export function useTrait(initialValue) {
    const [trait, updateTrait] = useState(initialValue);
 
    let current = trait;
 
    const get = () => current;
 
    const set = newValue => {
       current = newValue;
       updateTrait(newValue);
       return current;
    }
 
    return {
       get,
       set,
    }
 }

 export enum InternalDatasets {
    CANDIDATES = -1,
    VACANCIES = -2,
    BUSINESS = -3,
    BUSINESS_UNITS = -4,
    CONTACT = -5,
    USERS = -6,
     OFFERS = -7,
}
export const getInternalDataset = (id: any) => {
    switch (id) {
        case InternalDatasets.CANDIDATES:
            return {
                path: "Kandidaten",
                label: "Kandidaten"
            }
        case InternalDatasets.VACANCIES:
            return {
                path: "Vacatures",
                label: "Vacatures"
            }
        case InternalDatasets.BUSINESS:
            return {
                path: "Bedrijven",
                label: "Bedrijven"
            }
        case InternalDatasets.BUSINESS_UNITS:
            return {
                path: "Bedrijven",
                label: "Bedrijven"
            }
        case InternalDatasets.CONTACT:
            return {
                path: "Contact",
                label: "Contact"
            }
        case InternalDatasets.USERS:
            return {
                path: "Gebruikers",
                label: "Gebruikers"
            }
    }
}

export const getInternalDatasetIdByName = (name: any) => {
    switch (name) {
        case 'business':
            return InternalDatasets.BUSINESS;
        case 'business_unit':
        case 'company':
            return InternalDatasets.BUSINESS_UNITS;
        case 'candidate':
            return InternalDatasets.CANDIDATES;
        case 'contact':
            return InternalDatasets.CONTACT;
        case 'vacancy':
            return InternalDatasets.VACANCIES;
    }
}

export const getEntityRouteByInternalDataset = (dataset, id) => {
    switch (dataset) {
        case InternalDatasets.CANDIDATES:
            return ROUTE.CANDIDATE.VIEW(id);
        case InternalDatasets.VACANCIES:
            return ROUTE.VACANCY.VIEW(id);
        case InternalDatasets.BUSINESS:
            return ROUTE.BUSINESS.VIEW(id);
        case InternalDatasets.BUSINESS_UNITS:    
            return ROUTE.BUSINESS_UNIT.VIEW(id);
        case InternalDatasets.CONTACT:
            return ROUTE.CONTACT.VIEW(id);
        default:
            return null;
    }
}

export const generateCombinationFieldId = (fieldId, combinationFieldId) => encodeURI(`${fieldId}+${combinationFieldId}`);

export const getAccessTokenFromLocal = () => {
    const token: any = localStorage.getItem(window.btoa('accessToken'));
    const accessToken = window.atob(token);

    return accessToken;
}